var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { getType } from "typesafe-actions";
import * as quiz from "./actions";
export var initialState = null;
export var quizReducer = function quizReducer(state, action) {
  if (state === void 0) {
    state = initialState;
  }

  switch (action.type) {
    case getType(quiz.set):
      var deadline = action.payload.deadline;

      if (deadline && typeof deadline === "string") {
        action.payload.deadline = new Date(deadline);
      }

      return action.payload;

    case getType(quiz.clear):
      return initialState;

    case getType(quiz.setTitle):
      if (!state) {
        return state;
      }

      var newTexts = state && __assign({}, state.texts[0]);

      if (!newTexts) {
        return state;
      }

      newTexts.title = action.payload;
      return __assign({}, state, {
        texts: [newTexts]
      });

    default:
      return state;
  }
};